//@flow
import {call, put} from 'redux-saga/effects'

import {refreshOnAuthError} from '$util'

const generateRequestId: () => number = () => Math.floor(Math.random() * 10000000 + 1)

export default function callWithFlags(
  requestKey: string,
  fn: Generator<> | (any => Promise<mixed>),
  ...args: Array<mixed>
): Iterable<*> {

  return call(function*(): Generator<> {
    const key = generateRequestId()

    try {
      yield put({type: 'REQUEST/START', payload: {requestKey, key}})

      const result: Object = yield call(fn, ...args)

      yield put({type: 'REQUEST/SUCCESS', payload: {omitKey: key}})

      return result
    } catch (e) {
      if (e.response && e.response.status === 401 && requestKey !== 'refreshTokens') {

        try {

          const result: Object = yield call(refreshOnAuthError, fn, ...args)
          yield put({type: 'REQUEST/SUCCESS', payload: {omitKey: key}})
          return result

        } catch (err) {

          yield put({type: 'REQUEST/FAILURE', payload: {omitKey: key, error: err}})
          throw err
        }
      }
      console.dir(e)

      yield put({type: 'REQUEST/FAILURE', payload: {omitKey: key, error: e}})
      throw e
    }
  })
}



// WEBPACK FOOTER //
// ./src/util/callWithFlags.js